import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { ListMiniPopupControl } from "./ListMiniPopupControl";

export class ConfigListMiniPopupControl extends ListMiniPopupControl {
  constructor(options, initialSearchTerm) {
    super(options, initialSearchTerm);
    this.isConfigId = this.id + "_isConfig";
    this.isConfigContainerId = this.id + "_isConfigContainer";
  }
  toggleIsConfigCheckbox(user) {
    $("#" + this.isConfigId).prop("checked", false);
    if (AccountHolder.isConfigAdmin) {
      $("#" + this.isConfigContainerId).show();
    } else {
      $("#" + this.isConfigContainerId).hide();
    }
  }
  checkUser(user) {
    if (user) {
      this.toggleIsConfigCheckbox(user);
    }
  }
}
